enum PlaceType {
  Apartment = 'apartment',
  Home = 'home',
  Studio = 'studio',
  Bnb = 'bnb',
  SecondaryHousing = 'secondary_housing'
}

export default PlaceType
